import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bs-layout-home',
  templateUrl: './layout-home.component.html',
  styleUrls: ['./layout-home.component.scss']
})
export class LayoutHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
